export const FEATURED_VALUE_THRESHOLD = 70;
